import { useCallback, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import PhoneMenuEditor from '../components/PhoneMenuEditor';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fail(err) {
  const detail = err?.response?.data?.detail;
  const e = new Error(typeof detail === 'string' ? detail : (err?.message || 'Something went wrong'));
  if (Array.isArray(detail?.errors)) e.errors = detail.errors;
  return e;
}

export default function PhoneMenuPage() {
  const { token } = useAuth();
  const [aiNumber, setAiNumber] = useState('');
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/phone-menu`, { headers: { Authorization: `Bearer ${token}` } });
      setAiNumber(data.ai_number || '');
      return data;
    } catch (err) { throw fail(err); }
  }, [token]);
  const save = async (body) => {
    try { return (await axios.put(`${API}/phone-menu`, body, { headers })).data; } catch (err) { throw fail(err); }
  };
  const preview = async (body) => {
    try { return (await axios.post(`${API}/phone-menu/preview`, body, { headers })).data; } catch (err) { throw fail(err); }
  };
  const pretty = aiNumber.replace(/^\+1(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4 md:p-6" data-testid="phone-menu-page">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Phone Menu</h1>
        <p className="text-sm text-muted-foreground">
          Set up "press 1 for…, press 2 for…" for your business line. Your AI receptionist reads your words and
          forwards each key to that department's number. Changes apply to the next call.
        </p>
      </div>
      <PhoneMenuEditor load={load} save={save} preview={preview} numberLabel={pretty || 'your AI number'} />
    </div>
  );
}
